const { getOptions, getNotifications } = require('@/controllers/meta').ct_meta;

const initialState = () => ({
    loading: false,
    options: null,
    notifications: { count: 0, data: [] },
});

const state = initialState();

const mutations = {
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_OPTIONS(state, options) {
        state.options = options;
    },
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications;
    },
    RESET_META_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_loading(state) {
        return state.loading;
    },
    get_options(state) {
        return state.options;
    },
    get_notifications(state) {
        return state.notifications;
    },
};

const actions = {
    // valores dos selects: carregar uma vez e guardar
    async load_options({ commit }) {
        const response = await getOptions();

        if (!response.status) {
            throw response.error;
        }

        commit('SET_OPTIONS', response.data);
        return response.data;
    },

    // número do sino = count
    async load_notifications({ commit }) {
        const response = await getNotifications();

        if (!response.status) {
            throw response.error;
        }

        commit('SET_NOTIFICATIONS', { count: response.count, data: response.data });
        return response;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
